import intercomUtil from '@/utilities/intercom';

const state = {};

const actions = {
  async boot() {
    await intercomUtil.intercomBoot();
  },
  reboot() {
    intercomUtil.intercomReboot();
  }
};

export default {
  namespaced: true,
  state,
  actions
};
